import { useEffect } from "react";
import ScrollProgress from "@/components/feature/ScrollProgress";
import Navbar from "@/components/feature/Navbar";
import Hero from "@/components/feature/Hero";
import Services from "@/components/feature/Services";
import Projects from "@/components/feature/Projects";
import TechStack from "@/components/feature/TechStack";
import Solutions from "@/components/feature/Solutions";
import About from "@/components/feature/About";
import Process from "@/components/feature/Process";
import WhyUs from "@/components/feature/WhyUs";
import SocialLinks from "@/components/feature/SocialLinks";
import Contact from "@/components/feature/Contact";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import { useSiteContent } from "@/context/SiteContentContext";

export default function Home() {
  const { loading, error, refresh } = useSiteContent();

  useEffect(() => {
    refresh();
  }, [refresh]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center gap-4">
        <div className="w-10 h-10 rounded-full border-2 border-primary-200 border-t-primary-500 animate-spin" />
        <p className="text-sm text-foreground-600">Cargando…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center gap-4 px-4 text-center">
        <div className="w-14 h-14 rounded-full bg-red-50 text-red-500 flex items-center justify-center">
          <i className="ri-error-warning-line text-2xl" />
        </div>
        <p className="text-sm text-foreground-700">{error}</p>
        <button
          onClick={refresh}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap"
        >
          <i className="ri-refresh-line" />
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Projects />
        <TechStack />
        <Solutions />
        <About />
        <Process />
        <WhyUs />
        <SocialLinks />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}